import {
  setApplicationId,
  setApplicationStatus,
  setRespKtpSubmit
} from 'store/actions';

/**
 * to handle success resubmit ktp
 * @param {*} dispatch
 * @param {*} res
 * @param {*} action
 * @returns
 */
export const handleSuccessResubmitKtp = (dispatch, res, action) => {
  const data = res.data?.data;
  if (!data) return;

  dispatch(setRespKtpSubmit(data));
  dispatch(setApplicationId(data.applicationId));
  dispatch(setApplicationStatus(data.applicationStatus.cmCode));
  action.finish?.();
};
